import { IPhoneSchema } from '../../../../repositories/monolith-python/entities/offer/PhoneSchema';
import { ICalltracking, IOfferState } from '../../../../redux/reducers';

export const mapPhones = (offer: IOfferState, calltracking: ICalltracking): Array<IPhoneSchema> | null => {
  const { calltrackingPhoneSubstitutionsCount, isEnabled, isCompulsory } = calltracking;
  const { phones: phonesRaw, calltrackingPhoneIndex } = offer;

  if (!Array.isArray(phonesRaw)) {
    return null;
  }

  // Удалить телефоны null - падает Backend
  const phones = phonesRaw.filter(item => !!item && item.number) as Array<IPhoneSchema>;

  if (isEnabled && phones.length >= 1) {
    // Принудительный КТ имеет данные о том, сколько номеров можно подменить
    // Поэтому мы можем просто отбросить лишние номера
    if (isCompulsory) {
      return phones.slice(0, calltrackingPhoneSubstitutionsCount as number);
    }

    // Удаляем все номера, кроме выбранного в добровольном КТ
    if (phones.length >= 2) {
      return [phones[calltrackingPhoneIndex as number]];
    }
  }

  return phones;
};
